import React from "react";
import cx from "classnames";
import { Link } from "src/components/link";
import { Reveal } from "src/components/reveal";
import { Image } from "src/components/image";
import { BlockContent } from "src/components/block-content";
import { BackgroundLines } from "src/components/background-lines";
import { CTA } from "src/components/cta";

import { getInternalLinkPath } from "src/utils/getInternalLinkPath";

import styles from "./image-copy.module.css";

interface ImageCopyProps {
  module: {
    label?: string;
    headline?: string;
    copy?: any;
    cta?: any;
    image: any;
    imageAlignment?: string;
    backgroundColor?: string;
    backgroundLines?: {
      type: string;
      color: string;
      alignment: string;
    };
    verticalAlignment?: string;
    textAlignment?: string;
    headlineSize?: string;
  };
}
export const ImageCopy = ({ module }: ImageCopyProps) => {
  const {
    label,
    headline,
    copy,
    cta,
    image,
    imageAlignment,
    backgroundColor,
    backgroundLines,
    verticalAlignment,
    textAlignment,
    headlineSize
  } = module;
  return (
    <section
      className={cx(
        styles.imageCopy,
        styles[`${backgroundColor}`],
        imageAlignment === "left"
          ? styles.imageAlignLeft
          : styles.imageAlignRight,
        verticalAlignment === "center"
          ? styles.verticalAlignCenter
          : styles.verticalAlignOffset
      )}
    >
      {backgroundLines && (
        <BackgroundLines
          type={backgroundLines.type}
          color={backgroundLines.color}
          alignment={backgroundLines.alignment}
        />
      )}
      <div className={styles.imageCopyInner}>
        <div
          className={cx(
            styles.copyColumn,
            textAlignment === "left"
              ? styles.textAlignLeft
              : styles.textAlignCenter
          )}
        >
          <div className={styles.copyColumnInner}>
            <Reveal>
              {label && (
                <h4 className={cx("small-caps-13", styles.label)}>{label}</h4>
              )}
              {headline && (
                <h2
                  className={cx(
                    headlineSize === "large"
                      ? "headline headline--large"
                      : "headline",
                    styles.headline
                  )}
                >
                  {headline}
                </h2>
              )}
              {copy && <BlockContent className={styles.copy} blocks={copy} />}
              {cta && <CTA className={styles.cta} cta={cta} style="stroke" />}
            </Reveal>
          </div>
        </div>
        <div className={styles.imageColumn}>
          <div className={styles.imageWrapper}>
            <Reveal>
              {image && cta && (
                <Link
                  type="internalLink"
                  to={getInternalLinkPath(cta.link)}
                  ariaLabel={cta.linkCopy}
                >
                  <Image
                    className={styles.image}
                    imageId={image.asset._id}
                    width={420}
                    height={564}
                    alt={image.alt ? image.alt : ""}
                  />
                </Link>
              )}
              {image && !cta && (
                <Image
                  className={styles.image}
                  imageId={image.asset._id}
                  width={420}
                  height={564}
                  alt={image.alt ? image.alt : ""}
                />
              )}
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
